import { computed, observable } from 'mobx'
import ModelStore from '../../../shared-lib/stores/ModelStore'
import { $RootStore } from '../../../src/stores/RootStore'

export const defaultData: ConsultationForm = {
  _id: '',
  name: '',
  treatmentIds: [],
  questionIds: [],
  questions: [],
  applyToAllTreatments: false,
}

export type $ConsultationFormModel = ConsultationFormModel

export default class ConsultationFormModel extends ModelStore {
  @observable accessor data: ConsultationForm = { ...defaultData }
  removeMethodName = 'deleteConsultationForm'

  constructor(data: Partial<ConsultationForm>, rootStore: $RootStore) {
    super(data, rootStore)
    this.merge(data)
  }

  @computed get ownerId() {
    return this.data.professionalId
  }
}
